module.exports = __webpack_public_path__ + "static/media/findInstagramUrl2.8a7927e7.png";